/**
 * https://ckeditor.com/docs/ckeditor5/latest/features/table.html
 */
export default {
    table: {
        contentToolbar: [
            'tableRow',
            'tableColumn',
            'mergeTableCells',
        ],
    }
}
